export default __webpack_public_path__ + "static/fractal_horizontal-750df439b0dad2f9e703b595187c33e4.svg";